const processDataState = {
    state: null,
    sessionId: null,
    loading: false,
    uploadingTimeSeries: [],
    uploadingMetadata: [],
};
export default processDataState;
